<template>
  <div>
    <div
      ref="public-searchForm"
      class="public-searchForm work-search search-nowarp"
    >
      <el-form
        ref="searchForm"
        :model="searchForm"
        labelWidth="80px"
        @keyup.enter.native="search"
      >
        <el-form-item
          prop="statementName"
          label="报表名称"
        >
          <el-input
            v-model.trim="searchForm.statementName"
            clearable
            placeholder="请输入报表名称"
          />
        </el-form-item>
        <el-form-item
          v-show="false"
          prop="category"
        />
        <el-form-item
          prop="categoryName"
          label="报表分类"
        >
          <WSelectInput
            v-model="searchForm.categoryName"
            component="selectCategory"
            placeholder="请选择报表分类"
            title="请选择报表分类"
            inDialog
            :modelType="modelType"
            width="500px"
            @handleSelect="handleCategory"
          />
        </el-form-item>
        <el-form-item
          prop="templateType"
          label="对应表单"
        >
          <el-input
            v-model="searchForm.relevantFormName"
            size="small"
            readonly
            class="select-input"
            suffix-icon="el-icon-search"
            clearable
            @click.native="handleShowSelectForm"
          />
        </el-form-item>
        <div class="search-handler">
          <el-button
            icon="el-icon-refresh"
            @click="reset"
          >
            重置
          </el-button>
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="loading.search"
            @click="search"
          >
            查询
          </el-button>
        </div>
      </el-form>
    </div>
    <div class="public-table">
      <div class="public-table-top">
        <div class="table-title">
          报表列表
        </div>
      </div>
      <el-table
        v-if="showTable"
        ref="tableData"
        :height="tableHeight"
        :data="tableData"
        border
      >
        <el-table-column
          v-for="item in tableCol"
          :key="item.key"
          :prop="item.key"
          :label="item.label"
          :min-width="item.minWidth"
        />
        <el-table-column
          label="操作"
          minWidth="100"
          fixed="right"
        >
          <div
            slot-scope="scope"
            class="public-form-table-item-operate"
          >
            <el-button
              v-for="item in btnList"
              :key="item.type"
              type="text"
              @click="handleClick($event, scope.row,item.type)"
            >
              {{ item.label }}
            </el-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div
      ref="public-pagination"
      class="public-pagination"
    >
      <WPagination
        v-model="page"
        @change="query"
      />
    </div>
    <FormData
      v-if="showFormData"
      :formData="editObj"
      @close="showFormData = false"
    />
    <FormDialog
      v-if="showSelectForm"
      @formId="getFormId"
      @close="showSelectForm = false"
    />
  </div>
</template>
<script>
import handleButton from '@workflow/mixins/handleButton.js'
import tableHeight from '@workflow/mixins/tableHeight.js'
import FormData from './formData.vue'
import FormDialog from './formDialog.vue'
export default {
  name: 'Formx',
  components: {
    FormData,
    FormDialog
  },
  mixins: [handleButton, tableHeight],
  data() {
    return {
      showSelectForm: false,
      loading: {
        search: false
      },
      modelType: 2,
      showFormData: false,
      editObj: null,
      searchForm: {
        statementName: '',
        category: '',
        categoryName: '',
        relevantForm: '',
        relevantFormName: ''
      },
      selectParam: {},
      page: {},
      controlNum: 0,
      controlData: {},
      tableData: [],
      tableCol: [
        { label: '报表名称', key: 'statementName', minWidth: 150 },
        { label: '报表分类', key: 'categoryName', minWidth: 100 },
        { label: '对应表单', key: 'relevantForm', minWidth: 100 },
        { label: '创建人', key: 'updateBy', minWidth: 100 },
        { label: '创建时间', key: 'createTime', minWidth: 150 },
        { label: '描述', key: 'description', minWidth: 150 }
      ],
      fromList: [],
      btnList: [
        // { label: '修改', type: 0 },
        // { label: '删除', type: 1 },
        { label: '报表数据', type: 2 }
      ] // 修改 删除 报表数据
    }
  },
  mounted() {
    this.search()
    this.initFormList()
  },
  methods: {
    // 表单引用 表单列表弹窗
    handleShowSelectForm() {
      this.showSelectForm = true
    },
    getFormId(id, name, modelKey) {
      this.searchForm.relevantForm = modelKey
      this.searchForm.relevantFormName = name
    },
    handleClick($event, row, type) {
      switch (type) {
        case 2: {
          const paramsList = [
            `id=${row.statementId || ''}`,
            `title=${row.statementName || ''}`,
            `relevantForm=${row.relevantForm || ''}`
          ]
          const url = '/#/customerForm/formData?' + paramsList.join('&')
          window.open(url)
          break
        }
        default:
          break
      }
    },
    handleCategory({ id = '', name = '' } = {}) {
      this.searchForm.category = id
      this.searchForm.categoryName = name
    },
    reset() {
      this.$refs.searchForm.resetFields()
      this.searchForm.relevantForm = ''
      this.searchForm.relevantFormName = ''
      this.search()
    },
    search() {
      this.page.current = 1
      this.page.size = 10
      this.selectParam = { ...this.searchForm }
      delete this.selectParam.categoryName
      this.query()
    },
    query() {
      this.loading.search = true
      const { current, size } = this.page
      this.$api.customerForm.getTable({
        pageParam: { current, size },
        selectParam: this.selectParam
      }).then((data) => {
        this.controlData = {}
        this.tableData = data.records
        this.page.total = data.total
        if (!data.records.length) return this.$message.warning('查无数据！')
        // this.initBtnControl(++this.controlNum)
      }).finally(() => {
        this.loading.search = false
      })
    },
    initFormList() {
      this.$api.customerForm
        .getForm({
          pageParam: { current: 1, size: 9999 },
          selectParam: { modelType: 2, tenantId: '', name: '', modelKey: '' },
          sort: { fieldName: '', orderBy: '' }
        })
        .then((data) => {
          this.fromList = data.records
        })
    }
  }
}
</script>
